import React, { useState } from 'react';
import { Lock, User, Mail, LogIn, Phone, MapPin } from 'lucide-react';
import axios from 'axios';
import API_URL from '../config';

export default function Login({ onLogin }) {
  const [isRegister, setIsRegister] = useState(false);
  const [formData, setFormData] = useState({
    name: '', email: '', password: '', location: '', telephone: ''
  });

  const handleSubmit = async (e) => {
      e.preventDefault();
      
      // Validar campos básicos antes de enviar
      if (!formData.email || !formData.password) {
        alert("Por favor rellena todos los campos");
        return;
      }

      if (isRegister) {
        try {
          const res = await axios.post(`${API_URL}/api/register`, formData);
          alert(res.data.message);
          setIsRegister(false); // Cambia a login tras éxito
        } catch (err) {
          alert(err.response?.data?.message || "Error al registrar analista");
        }
      } else {
        try {
          const res = await axios.post(`${API_URL}/api/login`, {
            email: formData.email,
            password: formData.password
          });
          
          // Guardar sesión y entrar
          localStorage.setItem('session', JSON.stringify(res.data.user));
          onLogin(); 
        } catch (err) {
          alert(err.response?.data?.message || "Credenciales inválidas");
        }
      }
    };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="bg-slate-800 p-8 rounded-3xl shadow-2xl w-full max-w-md border border-slate-700">
        <h2 className="text-3xl font-black text-white text-center mb-2 italic uppercase tracking-tighter">
          KronoLogic
        </h2>
        <p className="text-slate-400 text-center text-xs mb-8 uppercase tracking-widest font-bold">
          {isRegister ? "Registro de Analista SA" : "Panel de Inteligencia"}
        </p>

        <form className="space-y-4" onSubmit={handleSubmit}>
          {isRegister && (
            <div>
              <label className="block text-[10px] font-black text-white uppercase mb-1 ml-1 tracking-widest">Nombre Completo</label>
              <div className="relative">
                <User className="absolute left-3 top-3 text-slate-500" size={18} />
                <input 
                  type="text" required
                  className="w-full bg-slate-900 border border-slate-700 rounded-xl py-2 pl-10 text-white outline-none focus:ring-2 focus:ring-yellow-500 transition-all"
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                />
              </div>
            </div>
          )}

          <div>
            <label className="block text-[10px] font-black text-white uppercase mb-1 ml-1 tracking-widest">Email Corporativo</label>
            <div className="relative">
              <Mail className="absolute left-3 top-3 text-slate-500" size={18} />
              <input 
                type="email" required
                className="w-full bg-slate-900 border border-slate-700 rounded-xl py-2 pl-10 text-white outline-none focus:ring-2 focus:ring-yellow-500 transition-all"
                onChange={(e) => setFormData({...formData, email: e.target.value})}
              />
            </div>
          </div>

          {isRegister && (
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-[10px] font-black text-white uppercase mb-1 ml-1 tracking-widest">Teléfono</label>
                <div className="relative">
                  <Phone className="absolute left-3 top-3 text-slate-500" size={16} />
                  <input 
                    type="text"
                    className="w-full bg-slate-900 border border-slate-700 rounded-xl py-2 pl-9 text-white text-sm outline-none focus:ring-2 focus:ring-yellow-500"
                    onChange={(e) => setFormData({...formData, telephone: e.target.value})}
                  />
                </div>
              </div>
              <div>
                <label className="block text-[10px] font-black text-white uppercase mb-1 ml-1 tracking-widest">Ubicación</label>
                <div className="relative">
                  <MapPin className="absolute left-3 top-3 text-slate-500" size={16} />
                  <input 
                    type="text"
                    className="w-full bg-slate-900 border border-slate-700 rounded-xl py-2 pl-9 text-white text-sm outline-none focus:ring-2 focus:ring-yellow-500"
                    onChange={(e) => setFormData({...formData, location: e.target.value})}
                  />
                </div>
              </div>
            </div>
          )}

          <div>
            <label className="block text-[10px] font-black text-white uppercase mb-1 ml-1 tracking-widest">Contraseña</label>
            <div className="relative">
              <Lock className="absolute left-3 top-3 text-slate-500" size={18} />
              <input 
                type="password" required
                className="w-full bg-slate-900 border border-slate-700 rounded-xl py-2 pl-10 text-white outline-none focus:ring-2 focus:ring-yellow-500 transition-all"
                onChange={(e) => setFormData({...formData, password: e.target.value})}
              />
            </div>
          </div>

          <button type="submit" className="w-full bg-yellow-500 hover:bg-yellow-400 text-black font-black py-3 rounded-xl flex items-center justify-center gap-2 transition-all active:scale-95 shadow-lg shadow-yellow-500/20 uppercase text-xs mt-6">
            {isRegister ? "Crear Cuenta KronoLogic" : "Ingresar al Sistema"} <LogIn size={18} />
          </button>
        </form>

        <div className="mt-8 text-center border-t border-slate-700 pt-6">
          <button 
            onClick={() => setIsRegister(!isRegister)}
            className="text-white text-[10px] font-black uppercase hover:text-yellow-500 transition-colors tracking-[0.15em]"
          >
            {isRegister ? "← Volver al Acceso" : "¿No tienes cuenta? Registra tu Banca"}
          </button>
        </div>
      </div>
    </div>
  );
}